import { render, staticRenderFns } from "./real-time.vue?vue&type=template&id=543d58e0&scoped=true&"
import script from "./real-time.vue?vue&type=script&lang=js&"
export * from "./real-time.vue?vue&type=script&lang=js&"
import style0 from "./real-time.vue?vue&type=style&index=0&id=543d58e0&prod&scoped=true&lang=scss&"
import style1 from "./real-time.vue?vue&type=style&index=1&id=543d58e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543d58e0",
  null
  
)

export default component.exports